
export const entriesMock = [
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    {
        id: 1,
        object: "Рубрика 2838489494",
        action: "Изменение названия",
        was: "Луна",
        became: "Лунная ночь на Днепре",
        user: "Cuindgi",
        time: "19.03.2024 20:11",
        selected: false
    },
    // ... можете добавить ещё
];